export default __webpack_public_path__ + "static/media/store-active.a1723cc0.svg";